import React from 'react';
import { Table as ReactstrapTable } from 'reactstrap';
import {
  gray150,
  gray200,
  gray600,
  white,
  tableHoverBg,
} from 'constants/colors';
import styled from 'styled-components';

type Border = {
  border: number | string;
};

type PropsType = {
  id?: string;
  children?: JSX.Element | string;
  borderTop?: boolean;
  tableLayoutFixed?: boolean;
  width?: number;
  height?: number;
  noMargin?: boolean;
  thAlign?: 'center' | 'left';
  withHighlight?: boolean;
  isStripe?: boolean;
  customBorder?: Border;
  noBorderCollapse?: boolean;
};

// テーブルの外観を設定
const StyledTable: React.FunctionComponent<PropsType> = ({
  id,
  children,
  borderTop = false,
  tableLayoutFixed = false,
  height,
  width,
  noMargin = false,
  thAlign = 'center',
  withHighlight = false,
  isStripe = false,
  customBorder,
  noBorderCollapse = false,
}) => (
  <Table
    id={id}
    tablelayoutfixed={tableLayoutFixed.toString()}
    bordertop={borderTop.toString()}
    height={height}
    width={width}
    nomargin={noMargin.toString()}
    thalign={thAlign}
    withhighlight={withHighlight.toString()}
    isstripe={isStripe.toString()}
    customborder={customBorder}
    nobordercollapse={noBorderCollapse.toString()}
  >
    {children}
  </Table>
);

const Table = styled(ReactstrapTable)`
  &.table {
    margin-bottom: 0 !important;
    ${({ nobordercollapse }) =>
      nobordercollapse === 'true' &&
      `
      border-collapse: separate !important;
      border-spacing: 0;
    `};
  }
  table-layout: ${props =>
    props.tablelayoutfixed === 'true' ? 'fixed' : 'auto'};
  border-top: ${props =>
    props.bordertop === 'true' ? `solid 2px ${gray600}` : ''};
  ${props =>
    props.height !== undefined &&
    `
    height: ${props.height}px;
    overflow-y: scroll;
  `};
  ${props => props.nomargin === 'true' && 'margin: 0'};

  tbody tr {
    ${props =>
      props.withhighlight === 'true'
        ? `&:hover {
            td:not(.sticky) {
              background-color: transparent !important;
            }
            background-color: ${tableHoverBg};
          }`
        : ''};
  }

  thead > tr > th {
    color: ${white};
    text-align: center;
    vertical-align: middle;
    background-color: ${gray600};
    border-right: 2px solid ${white};
    border-bottom: 2px solid ${white};
  }

  tbody tr:nth-child(odd) td {
    ${props =>
      props.isstripe === 'true' ? `background-color: ${gray150}; ` : ''};
  }

  tbody > tr:last-child > th,
  tbody td {
    ${props =>
      props.customborder
        ? props.customborder
        : `border-bottom: 1px solid ${gray200}`};
  }
  tbody th {
    width: 190px;
    height: 30px;
    color: ${white};
    text-align: ${props => props.thalign};
    vertical-align: middle;
    background-color: ${gray600};
  }
`;

export default StyledTable;
